// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
/*** Color Variables *****/
.property-card {
  width: 860px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  margin-bottom: 40px;
}
.property-card__content {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}
.property-card__image-container {
  flex-shrink: 0;
}
.property-card__image img {
  width: 256px;
  height: 172px;
  background: #e9ecec;
  border-radius: 6px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.property-card img[src*="frame-landscape.svg"] {
  object-fit: contain;
  padding: 60px;
}
.property-card__details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 17px;
}
.property-card__header {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.property-card__price-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.property-card__price {
  color: black;
  font-size: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  line-height: 24px;
  word-wrap: break-word;
}
.property-card__status {
  border-radius: 2px;
  border: none;
  padding: 4px 6px;
  text-align: right;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.property-card__address {
  align-self: stretch;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #13171F;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
}
.property-card__action-section {
  padding: 12px 20px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 82px;
}
.property-card__action-content {
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  gap: 12px;
}
.property-card__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.property-card__action-text {
  color: #273142;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: "Roboto", sans-serif;
}
.property-card__continue-btn {
  border: 1px solid #4cb8ac;
  color: #4cb8ac;
  font-weight: 700;
  font-size: 16px;
  padding: 8px 20px;
  height: auto;
  background: white;
  border-radius: 54px;
  outline-offset: -0.5px;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  display: inline-flex;
}
.property-card__continue-btn .btn-text {
  text-align: center;
  color: #4CB8AC;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  line-height: 20px;
  word-wrap: break-word;
}
.property-card__continue-btn .anticon {
  margin-left: 12px;
}
.property-card__completed-actions {
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.property-card__completed-actions .ant-row {
  width: 100%;
}
.property-card__completed-actions .ant-row:not(:last-child) {
  margin-bottom: 0;
}
.property-card__completed-actions .ant-col {
  padding: 0;
}
.property-card__action-button {
  width: 100%;
  height: 40px;
  padding: 12px 20px;
  background: white;
  border: 1px solid #CACCCC;
  border-radius: 0;
  outline: none;
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: flex;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: "Roboto", sans-serif;
}
.property-card__action-button:hover, .property-card__action-button:focus {
  background-color: #F5FEFF;
  border-color: #4CB8AC;
  color: inherit;
}
.property-card__action-button.ant-btn {
  background: white;
  border-color: #CACCCC;
}
.property-card__action-button.ant-btn:hover, .property-card__action-button.ant-btn:focus {
  background-color: #F5FEFF;
  border-color: #4CB8AC;
  color: inherit;
}
.property-card__action-button--top-left {
  border-top-left-radius: 6px;
  border-bottom: 0.5px;
  border-right: 0.5px;
}
.property-card__action-button--top-right {
  border-top-right-radius: 6px;
  border-bottom: 0.5px;
}
.property-card__action-button--bottom-left {
  border-bottom-left-radius: 6px;
  border-right: 0.5px;
}
.property-card__action-button--bottom-right {
  border-bottom-right-radius: 6px;
}
.property-card__action-button-content {
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
}
.property-card__action-button-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.property-card__action-button-text {
  color: #4CB8AC;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  word-wrap: break-word;
}
@media (max-width: 480px) {
  .property-card {
    width: 100%;
    max-width: 375px;
    margin-bottom: 20px;
  }
  .property-card__content {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
  .property-card__image-container {
    align-self: stretch;
  }
  .property-card__image img {
    width: 330px;
    height: 232px;
  }
  .property-card img[src*="frame-landscape.svg"] {
    object-fit: contain;
    padding: 80px;
  }
  .property-card__details {
    gap: 20px;
  }
  .property-card__header {
    gap: 8px;
  }
  .property-card__action-section {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 12px 20px;
    align-items: stretch;
  }
  .property-card__action-content {
    align-self: stretch;
    justify-content: flex-start;
  }
  .property-card__continue-btn {
    align-self: stretch;
    justify-content: center;
    width: 100%;
    padding: 8px 20px;
  }
  .property-card__completed-actions {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
  }
  .property-card__completed-actions .ant-row {
    display: block;
    margin: 0;
    width: 100%;
  }
  .property-card__completed-actions .ant-col {
    width: 100% !important;
    max-width: 100%;
    padding: 0;
  }
  .property-card__completed-actions .property-card__action-button {
    width: 100%;
    border-radius: 0;
    border: 1px solid #CACCCC;
  }
  .property-card__completed-actions .property-card__action-button--top-left {
    border-radius: 6px 6px 0 0;
    border-bottom: none;
  }
  .property-card__completed-actions .property-card__action-button--top-right {
    border-bottom: none;
  }
  .property-card__completed-actions .property-card__action-button--bottom-right {
    border-radius: 0 0 6px 6px;
  }
  .property-card__completed-actions .property-card__action-button--bottom-left {
    border-bottom: none;
  }
}

.property-card__status.forsale {
  background: #dff7f9;
  color: #4cb8ac !important;
}

.property-card__status.salepending {
  background: #fff2dc;
  color: #f5a623 !important;
}

.property-card__status.contingent {
  background: #f1e7ff;
  color: #bb8eff !important;
}

.property-card__status.withdrawn {
  background: #fff0e2;
  color: #b78151 !important;
}

.property-card__status.sold {
  background: #ffebee;
  color: #eb6777 !important;
}

.property-card__status.inreview {
  background: #E2EFFF;
  color: #4A90E2 !important;
}

@media (min-width: 481px) and (max-width: 900px) {
  .property-card {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/sharedmodule/components/property-list-item/property-list-item.component.scss"],"names":[],"mappings":"AAAA,8EAAA;AAQA,0BAAA;ACNA;EACE,YAAA;EAEA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAIE;EACI,mBAAA;EACA,aAAA;AAFN;AAKE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AALJ;AAQE;EACE,YAAA;EACA,eAAA;EACA,iCDiCU;EChCV,gBAAA;EACA,iBAAA;EACA,qBAAA;AANJ;AASE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCDsBU;ECrBV,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,iCDQU;ECPV,gBAAA;EACA,iBAAA;EACA,qBAAA;AARJ;AAWE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AATJ;AAYE;EACE,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAXJ;AAcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCD7BU;ACiBd;AAeE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAbJ;AAeI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iCDnDQ;ECoDR,gBAAA;EACA,iBAAA;EACA,qBAAA;AAbN;AAgBI;EACE,iBAAA;AAdN;AAkBE;EACE,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;AAhBJ;AAkBI;EACE,WAAA;AAhBN;AAkBM;EACE,gBAAA;AAhBR;AAoBI;EACE,UAAA;AAlBN;AAsBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,sCAAA;EACA,iCDjGU;AC6Ed;AAsBI;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AArBN;AA4BI;EACE,iBAAA;EACA,qBAAA;AA1BN;AA4BM;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AA3BR;AA+BI;EACE,2BAAA;EACA,oBAAA;EACA,mBAAA;AA7BN;AAgCI;EACE,4BAAA;EACA,oBAAA;AA9BN;AAiCI;EACE,8BAAA;EACA,mBAAA;AA/BN;AAkCI;EACE,+BAAA;AAhCN;AAmCI;EACE,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;AAjCN;AAoCI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlCN;AAqCI;EACE,cAAA;EACA,eAAA;EACA,iCD/JQ;ECgKR,gBAAA;EACA,qBAAA;AAnCN;AAsCE;EA9PF;IA+PI,WAAA;IACA,gBAAA;IACA,mBAAA;EAnCF;EAqCE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAnCJ;EAsCE;IACE,mBAAA;EApCJ;EAuCE;IACE,YAAA;IACA,aAAA;EArCJ;EAwCE;IACE,mBAAA;IACA,aAAA;EAtCJ;EAyCE;IACE,SAAA;EAvCJ;EA0CE;IACE,QAAA;EAxCJ;EA2CE;IACE,sBAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,oBAAA;EAzCJ;EA4CE;IACE,mBAAA;IACA,2BAAA;EA1CJ;EA6CE;IACE,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,iBAAA;EA3CJ;EA6CE;IACE,aAAA;IACA,sBAAA;IACA,MAAA;IACA,WAAA;EA3CJ;EA6CI;IACE,cAAA;IACA,SAAA;IACA,WAAA;EA3CN;EA8CI;IACE,sBAAA;IACA,eAAA;IACA,UAAA;EA5CN;EA+CI;IACE,WAAA;IACA,gBAAA;IACA,yBAAA;EA7CN;EA+CM;IACE,0BAAA;IACA,mBAAA;EA7CR;EA+CM;IACE,mBAAA;EA7CR;EA+CM;IACE,0BAAA;EA7CR;EA+CM;IACE,mBAAA;EA7CR;AACF;;AAmDA;EACE,mBD/RW;ECgSX,yBAAA;AAhDF;;AAmDA;EACE,mBDlSe;ECmSf,yBAAA;AAhDF;;AAmDA;EACE,mBDrSc;ECsSd,yBAAA;AAhDF;;AAmDA;EACE,mBDtSa;ECuSb,yBAAA;AAhDF;;AAmDA;EACE,mBD7SQ;EC8SR,yBAAA;AAhDF;;AAmDA;EACE,mBD9SY;EC+SZ,yBAAA;AAhDF;;AAmDA;EACE;IACE,WAAA;EAhDF;AACF","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n$import-theme-font: Roboto;\n\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');\n\n$base-font: 'Roboto', sans-serif;\n$heading-font: 'Roboto', sans-serif;\n\n/*** Color Variables *****/\n$dark: #13192d;\n$light: #f9f9f9;\n$light-gray: #eff4f5;\n$white: #fff;\n$black: #000000;\n$primary: #4cb8ac;\n$light-primary: #dff7f9;\n$clight-primary: #e3fbf8;\n$xlight-primary: #f5fbfc;\n$primary-hover: #4cb8ac;\n$secondary: #4179bd;\n$secondary-hover: #3a6daa;\n$placeholder-color: #b7b9c1;\n$alert: #d0031c;\n$pending: #ff7a0a;\n$close: #1f60c3;\n$red: #d0031c;\n$success-green: #52c41a;\n$blue: #0053af;\n$light-blue: #f2fffe;\n$error:#ff4d4f;\n$primary-ghost: #e4f8f9;\n\n$top-nav-color: none;\n$dark-text-clr: #13171f;\n$gray-text-clr: #656c78;\n$gray-text-clr-1: #616b7d;\n$mgray-text-clr: #7e828c;\n$mgray-text-clr-1: #7d8494;\n$lgray-text-clr: #acb2be;\n// $footer-bg: #2f3b3d;\n$footer-bg: #0c1a38;\n$footer-text-clr: rgba(255, 255, 255, 0.59);\n\n$left-nav-clr: #12161f;\n$left-nav-icon: #515b72;\n\n$input-bg: #fcfcfc;\n$input-b-clr: #e8e8e8;\n$input-br-clr: #ccd8db;\n$input-lbl-clr: #566074;\n$checkbox-txt-clr: #5f636c;\n\n$modal-h-clr: #3b414d;\n$detail-bg: #fcfbfb;\n\n$google: #db4437;\n$facebook: #3b5998;\n\n$mail-clr: #4cb8ac;\n$fb-clr: #475993;\n$twt-clr: #03a9f4;\n$in-clr: #0077b7;\n\n$forsale-bg: #dff7f9;\n$forsale-clr: #4cb8ac;\n$salepending-bg: #fff2dc;\n$salepending-clr: #f5a623;\n$contingent-bg: #f1e7ff;\n$contingent-clr: #bb8eff;\n$sold-bg: #ffebee;\n$sold-clr: #eb6777;\n$withdrawn-bg: #fff0e2;\n$withdrawn-clr: #b78151;\n$inreview-bg: #E2EFFF;\n$inreview-clr: #4A90E2;\n$for-rent-bg: #e2efff;\n$for-rent-clr: #4a90e2;\n$offer-pending-clr: #efa92b;\n$offer-pending-bg: #fdf8ed;\n$offer-accepted-clr: #4cb8ac;\n$offer-accepted-bg: #edf7f6;\n\n$primary-color: #3a7ca5;\n$secondary-color: #4cb8ac;\n$background-color: #f4f4f8;\n$text-color: #333;\n$border-color: #e0e0e0;\n$disable-color: #a0a0a0;\n\n$primary-teal: #4CB8AC;\n$primary-teal-hover: #3da396;\n$text-white: white;\n$font-family: 'Roboto', sans-serif;\n$dark-bg: #12161F;\n\n$line-through-text-clr: #71747E;","@use './../../../../variables.scss' as *;\n\n.property-card {\n  width: 860px;\n  // height: 200px;\n  border-radius: 8px;\n  background: #FFF;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);\n  margin-bottom: 40px;\n\n  &__content {\n    display: flex;\n    gap: 24px;\n    align-items: flex-start;\n  }\n\n  &__image-container {\n    flex-shrink: 0;\n  }\n\n  &__image img {\n    width: 256px; \n    height: 172px;\n    background: #e9ecec;\n    border-radius: 6px;\n    background-size: cover;\n    background-position: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  img[src*=\"frame-landscape.svg\"] {\n      object-fit: contain;\n      padding: 60px; \n  }\n\n  &__details {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 17px;\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__price-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__price {\n    color: black; \n    font-size: 20px;\n    font-family: $font-family;\n    font-weight: 700; \n    line-height: 24px; \n    word-wrap: break-word;\n  }\n\n  &__status {\n    border-radius: 2px;\n    border: none;\n    padding: 4px 6px;\n    text-align: right;\n    font-family: $font-family;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  &__address {\n    align-self: stretch; \n    justify-content: center; \n    display: flex; \n    flex-direction: column; \n    color: #13171F; \n    font-size: 16px; \n    font-family: $font-family;\n    font-weight: 400; \n    line-height: 20px; \n    word-wrap: break-word\n  }\n\n  &__action-section {\n    padding: 12px 20px;\n    background: white;\n    border-radius: 6px;\n    border: 1px solid #e5e5e5;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    height: 82px;\n  }\n\n  &__action-content {\n    align-self: stretch; \n    justify-content: flex-start;\n    align-items: center; \n    display: inline-flex;\n    gap: 12px;\n  }\n\n  &__icon-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__action-text {\n    color: #273142;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    font-family: $font-family;\n  }\n\n  &__continue-btn {\n    border: 1px solid #4cb8ac;\n    color: #4cb8ac;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 8px 20px;\n    height: auto;\n    background: white; \n    border-radius: 54px; \n    outline-offset: -0.50px; \n    justify-content: flex-end; \n    align-items: center; \n    gap: 12px; \n    display: inline-flex;\n    \n    .btn-text {\n      text-align: center;\n      color: #4CB8AC;\n      font-size: 16px; \n      font-family: $font-family;\n      font-weight: 700; \n      line-height: 20px; \n      word-wrap: break-word\n    }\n     \n    .anticon {\n      margin-left: 12px;\n    }\n  }\n\n  &__completed-actions {\n    align-self: stretch;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    \n    .ant-row {\n      width: 100%;\n      \n      &:not(:last-child) {\n        margin-bottom: 0;\n      }\n    }\n    \n    .ant-col {\n      padding: 0;\n    }\n  }\n\n  &__action-button {\n    width: 100%;\n    height: 40px;\n    padding: 12px 20px;\n    background: white;\n    border: 1px solid #CACCCC;\n    border-radius: 0;\n    outline: none;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    display: flex;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    font-family: $font-family;\n\n    &:hover,\n    &:focus {\n      background-color: #F5FEFF;\n      border-color: #4CB8AC;\n      color: inherit;\n    }\n\n    // &:active {\n    //   background-color: #f8f9fa;\n    // }\n\n    &.ant-btn {\n      background: white;\n      border-color: #CACCCC;\n      \n      &:hover,\n      &:focus {\n        background-color: #F5FEFF;\n        border-color: #4CB8AC;\n        color: inherit;\n      }\n    }\n\n    &--top-left {\n      border-top-left-radius: 6px;\n      border-bottom: 0.5px;\n      border-right: 0.5px;\n    }\n\n    &--top-right {\n      border-top-right-radius: 6px;\n      border-bottom: 0.5px;\n    }\n\n    &--bottom-left {\n      border-bottom-left-radius: 6px;\n      border-right: 0.5px;\n    }\n\n    &--bottom-right {\n      border-bottom-right-radius: 6px;\n    }\n\n    &-content {\n      justify-content: center;\n      align-items: center;\n      gap: 8px;\n      display: flex;\n    }\n\n    &-icon {\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    &-text {\n      color: #4CB8AC;\n      font-size: 14px;\n      font-family: $font-family;\n      font-weight: 500;\n      word-wrap: break-word;\n    }\n  } \n  @media (max-width: 480px) {\n    width: 100%;\n    max-width: 375px;\n    margin-bottom: 20px;\n\n    &__content {\n      flex-direction: column;\n      gap: 20px;\n      align-items: stretch;\n    }\n\n    &__image-container {\n      align-self: stretch;\n    }\n\n    &__image img {\n      width: 330px;\n      height: 232px;\n    }\n\n    img[src*=\"frame-landscape.svg\"] {\n      object-fit: contain;\n      padding: 80px; \n    }\n\n    &__details {\n      gap: 20px;\n    }\n\n    &__header {\n      gap: 8px;\n    }\n\n    &__action-section {\n      flex-direction: column;\n      height: auto;\n      gap: 12px;\n      padding: 12px 20px;\n      align-items: stretch;\n    }\n\n    &__action-content {\n      align-self: stretch;\n      justify-content: flex-start;\n    }\n\n    &__continue-btn {\n      align-self: stretch;\n      justify-content: center;\n      width: 100%;\n      padding: 8px 20px;\n    }\n    &__completed-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 0; \n      width: 100%;\n\n      .ant-row {\n        display: block;\n        margin: 0;\n        width: 100%;\n      }\n\n      .ant-col {\n        width: 100% !important;\n        max-width: 100%;\n        padding: 0;\n      }\n\n      .property-card__action-button {\n        width: 100%;\n        border-radius: 0;\n        border: 1px solid #CACCCC;\n\n        &--top-left{\n          border-radius: 6px 6px 0 0;\n          border-bottom: none; \n        }\n        &--top-right{\n          border-bottom: none; \n        }\n        &--bottom-right{\n          border-radius: 0 0 6px 6px; \n        }\n        &--bottom-left{\n          border-bottom: none;  \n        }\n       }\n      }\n    }\n  }\n\n.property-card__status.forsale {\n  background: $forsale-bg;\n  color: $forsale-clr !important;\n}\n\n.property-card__status.salepending {\n  background: $salepending-bg;\n  color: $salepending-clr !important;\n}\n\n.property-card__status.contingent {\n  background: $contingent-bg;\n  color: $contingent-clr !important;\n}\n\n.property-card__status.withdrawn {\n  background: $withdrawn-bg;\n  color: $withdrawn-clr !important;\n}\n\n.property-card__status.sold {\n  background: $sold-bg;\n  color: $sold-clr !important;\n}\n\n.property-card__status.inreview {\n  background: $inreview-bg;\n  color: $inreview-clr !important;\n}\n\n@media (min-width: 481px) and (max-width: 900px) {\n  .property-card { \n    width:100%;\n  } \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
